/* ============================================================================
   pers-gotowy-buybox.js — buy box gotowych wzorów (produkty wariantowe
   ORAZ jednowariantowe — od zadania 31, patrz „SKĄD DANE").

   ── CO TO ROBI, A CZEGO NIE ───────────────────────────────────────────────
   NIE przejmuje wyboru wariantu. Motyw ma własny `<variant-radios>` i własny
   skrypt, który na zmianę radia podmienia `input[name=id]`, cenę i galerię.
   Ten plik tylko CZYTA ten stan i dokłada to, czego motyw nie ma:

     1. cenę pod każdym kafelkiem rozmiaru (przeliczaną po zmianie koloru),
     2. wiersz „Razem" nad przyciskiem — JEDYNE miejsce z sumą,
     3. chipy ilości z rabatem i podmianę etykiet opcji (sam render),
     4. treść paska podążającego,
     5. kolejność bloków: wybór wariantu przed ilością i przyciskiem.

   Przycisk „Dodaj do koszyka" NIE dostaje kwoty. Dwie sumy na jednym ekranie
   kazały klientowi sprawdzać, czy się zgadzają — a przy rabacie ilościowym
   potrafiły się różnić. Suma jest jedna, w „Razem (brutto)".

   Zero zapisów do pól formularza. Zero własnego submit. Klikamy wyłącznie
   te radia, które i tak są klikalne dla użytkownika — i tylko wtedy, gdy
   użytkownik kliknie nasz kafelek, który jest ich etykietą.

   ── SKĄD DANE ────────────────────────────────────────────────────────────
   `<variant-radios>` niesie już `<script type="application/json">` z pełną
   listą wariantów (motyw używa go do własnej podmiany). Czytamy ten sam
   węzeł — nie dokładamy drugiego źródła prawdy o cenach.

   Produkt JEDNOWARIANTOWY (sam „Title") nie ma `<variant-radios>`, więc nie ma
   też tego JSON-a. Wtedy — i TYLKO wtedy — sekcja dokłada atrybut `data-warianty`
   z `product.variants | json` (ten sam kształt). Archeologia (zadanie 31):
   żadna wersja tego pliku od zadania 12 nie miała tej gałęzi — skrypt zawsze
   kończył się przy braku kafli; to nowa budowa, nie naprawa regresji.
   ============================================================================ */

(function () {
  'use strict';

  var KONF = document.getElementById('pgb-konfiguracja');
  if (!KONF || KONF.dataset.wlaczony !== 'true') return;

  // `korzen` (kafle wariantów motywu) może NIE ISTNIEĆ: produkt jednowariantowy
  // nie ma `<variant-radios>`. Do zadania 31 skrypt kończył się tu i produkt
  // na tym szablonie nie miał żadnej widocznej ceny. Teraz dane biorą się
  // z JSON-a, który sekcja renderuje WYŁĄCZNIE przy jednym wariancie.
  var korzen = document.querySelector('#main-product variant-radios');
  var formularz = document.querySelector('#main-product form[action*="/cart/add"]');
  if (!formularz) return;

  /* ---------------------------------------------------------- dane */

  var warianty = [];
  try {
    if (korzen) {
      var json = korzen.querySelector('script[type="application/json"]');
      warianty = json ? JSON.parse(json.textContent) : [];
    } else {
      // Jeden wariant: dane z atrybutu węzła konfiguracji (sekcja renderuje go
      // WYŁĄCZNIE przy has_only_default_variant).
      warianty = KONF.dataset.warianty ? JSON.parse(KONF.dataset.warianty) : [];
    }
  } catch (e) { return; }              // bez danych nie ma czego liczyć
  if (!warianty.length) return;

  var WALUTA = KONF.dataset.waluta || 'zł';

  // Ceny w JSON-ie Shopify sa w GROSZACH. Formatujemy sami, bo `Intl` bywa
  // wylaczony w starszych przegladarkach, a kwota na przycisku to nie miejsce
  // na niespodzianki.
  function kwota(grosze) {
    var z = (grosze / 100).toFixed(2).replace('.', ',');
    return z.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + WALUTA;
  }

  /* ------------------------------------------------- odczyt stanu */

  // Bez kafli (jeden wariant) nie ma zestawów opcji — `wybrane()` daje wtedy
  // pustą listę, a `znajdzWariant([])` zwraca jedyny wariant.
  function zestawy() {
    return korzen ? Array.prototype.slice.call(korzen.querySelectorAll('fieldset')) : [];
  }

  // Wybrane wartosci w kolejnosci opcji — dokladnie tak, jak Shopify sklada
  // `variant.options`. Kolejnosc bierzemy z DOM, nie z nazw.
  function wybrane() {
    return zestawy().map(function (f) {
      var z = f.querySelector('input[type="radio"]:checked');
      return z ? z.value : null;
    });
  }

  function znajdzWariant(opcje) {
    for (var i = 0; i < warianty.length; i++) {
      var w = warianty[i], zgadza = true;
      for (var j = 0; j < opcje.length; j++) {
        if (opcje[j] == null) continue;          // ta opcja nas nie interesuje
        if (w.options[j] !== opcje[j]) { zgadza = false; break; }
      }
      if (zgadza) return w;
    }
    return null;
  }

  function aktualny() { return znajdzWariant(wybrane()); }

  function ilosc() {
    var p = formularz.querySelector('input[name="quantity"]')
      || document.querySelector('#main-product input[name="quantity"]');
    var n = p ? parseInt(p.value, 10) : 1;
    return isFinite(n) && n > 0 ? n : 1;
  }

  /* ------------------------------------- 1. ceny pod kafelkami rozmiaru */

  // Ktory zestaw jest kolorem, a ktory rozmiarem — rozstrzyga SEKCJA, w Liquidzie,
  // po wartosciach opcji (nie po nazwie wyswietlanej, ktora jest trescia i moze
  // sie zmienic w panelu). Tu tylko odczytujemy jej ustalenie.
  var indeksKoloru = parseInt(KONF.dataset.indeksKoloru, 10);
  if (!isFinite(indeksKoloru)) indeksKoloru = -1;

  var etykietyCen = [];

  // Ktore grupy dostaja cene pod pigulka. Puste ustawienie = wszystkie poza
  // kolorem (zachowanie sprzed 18B). Przy wizytowkach cena zalezy WYLACZNIE
  // od nakladu, wiec ta sama kwota pod „50x90 mm" i pod „Dwustronny" tylko
  // by mylila — tam lista to jedno slowo: Nakład.
  var GRUPY_Z_CENA = String(KONF.dataset.grupyZCena || '')
    .split(',').map(function (s) { return s.trim().toLowerCase(); })
    .filter(function (s) { return s; });

  function grupaMaCene(f, indeks) {
    if (indeks === indeksKoloru) return false;
    if (!GRUPY_Z_CENA.length) return true;
    // Czytamy ORYGINALNA nazwe opcji: `zbudujCeny` biegnie przed podmiana
    // etykiet, wiec w `<legend>` stoi jeszcze nazwa z admina. To ona jest
    // kontraktem — nazwa wyswietlana jest trescia i moze sie zmienic.
    var leg = f.querySelector('legend');
    var nazwa = leg ? String(leg.textContent || '').trim().toLowerCase() : '';
    return GRUPY_Z_CENA.indexOf(nazwa) >= 0;
  }

  function zbudujCeny() {
    zestawy().forEach(function (f, indeks) {
      if (!grupaMaCene(f, indeks)) return;
      f.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var label = f.querySelector('label[for="' + radio.id + '"]');
        if (!label || label.querySelector('.pgb-cena')) return;
        var el = document.createElement('span');
        el.className = 'pgb-cena';
        label.appendChild(el);
        etykietyCen.push({ el: el, indeks: indeks, wartosc: radio.value, label: label });
      });
    });
  }

  function odswiezCeny() {
    var stan = wybrane();
    etykietyCen.forEach(function (p) {
      // Cena TEGO rozmiaru przy AKTUALNIE wybranym kolorze. Dlatego kopiujemy
      // stan i podmieniamy tylko jedna pozycje — inaczej pokazalibysmy cene
      // wariantu, ktorego uzytkownik nie wybiera.
      var szukaj = stan.slice();
      szukaj[p.indeks] = p.wartosc;
      var w = znajdzWariant(szukaj);
      if (!w) { p.el.textContent = ''; p.label.classList.remove('pgb-niedostepny'); return; }
      p.el.textContent = kwota(w.price);
      p.label.classList.toggle('pgb-niedostepny', w.available === false);
    });
  }

  /* ------------------------------------------------- 2. etykiety opcji

     WARSTWA RENDERU, NIE DANE. Nazwy opcji i wartosci wariantow zostaja
     w adminie nietkniete — ida przez BaseLinker do Allegro. Podmieniamy
     WYLACZNIE to, co widzi klient: tekst `<legend>` i tekst w pigulce.
     Atrybuty `name=` i `value=` formularza zostaja bez zmian. */

  function mapaEtykiet() {
    var mapa = {};
    String(KONF.dataset.mapaEtykiet || '').split(',').forEach(function (para) {
      var cz = para.split(':');
      if (cz.length !== 2) return;
      var z = cz[0].trim(), na = cz[1].trim();
      if (z && na) mapa[z.toLowerCase()] = na;
    });
    return mapa;
  }

  function podmienLegendy() {
    var mapa = mapaEtykiet();
    var korzenOpcji = document.querySelector('#main-product variant-radios');
    if (!korzenOpcji) return;
    korzenOpcji.querySelectorAll('legend').forEach(function (leg) {
      var nowa = mapa[String(leg.textContent || '').trim().toLowerCase()];
      if (nowa) leg.textContent = nowa;
    });
  }

  // Sufiksy obcinane z WIDOCZNEJ wartosci pigulki. Odpornosc na zapis:
  // slowa laczymy `\s+`, porownujemy bez wzgledu na wielkosc liter, a wartosc
  // bez sufiksu zostaje nietknieta.
  function wzorceSufiksow() {
    var out = [];
    String(KONF.dataset.sufiksy || '').split(',').forEach(function (s) {
      var t = s.trim();
      if (!t) return;
      var slowa = t.split(/\s+/).map(function (w) {
        return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      });
      out.push(new RegExp('[\\s\\-–—]*' + slowa.join('\\s+') + '\\s*$', 'i'));
    });
    return out;
  }

  // Swatche bez podpisu potrzebuja tooltipa — nazwa koloru znika WIZUALNIE
  // (`font-size:0` w sekcji), ale musi zostac osiagalna mysza i czytnikiem.
  // Tekst etykiety zostaje nietkniety: to on jest nazwa dostepna dla radia.
  // Dokladamy wylacznie `title`.
  function dodajTooltipyKolorow() {
    if (KONF.dataset.rzadOpcji !== 'true' || indeksKoloru < 0) return;
    var zestawKolorow = zestawy()[indeksKoloru];
    if (!zestawKolorow) return;
    zestawKolorow.querySelectorAll('label').forEach(function (label) {
      var nazwa = String(label.textContent || '').trim();
      if (nazwa && !label.getAttribute('title')) label.setAttribute('title', nazwa);
    });
  }

  function skrocWartosci() {
    var wzorce = wzorceSufiksow();
    if (!wzorce.length) return;
    var korzenOpcji = document.querySelector('#main-product variant-radios');
    if (!korzenOpcji) return;

    korzenOpcji.querySelectorAll('label').forEach(function (label) {
      // Tylko WEZLY TEKSTOWE. Pigulka ma juz w srodku `<span class="pgb-cena">`
      // z ceną, a przy kolorach bywa `<img>` — przepisanie `innerHTML`
      // skasowaloby jedno i drugie.
      for (var i = 0; i < label.childNodes.length; i++) {
        var w = label.childNodes[i];
        if (w.nodeType !== 3) continue;
        var tekst = w.nodeValue;
        if (!tekst || !tekst.trim()) continue;
        for (var j = 0; j < wzorce.length; j++) {
          var skrocony = tekst.replace(wzorce[j], '');
          if (skrocony !== tekst) { w.nodeValue = skrocony; break; }
        }
      }
    });
  }

  /* ------------------------------------------ 2a. drabinka rabatow i chipy

     DRABINKA JEST JEDYNYM ZRODLEM LICZB. Te same wartosci rysuja chip, procent
     na znaczniku i kwote po rabacie w wierszu „Razem". Baner rabatu zostal
     zdjety, wiec nie ma drugiego miejsca, ktore moglo by mowic co innego. */

  // Straznik zasiegu liczy SEKCJA, w Liquidzie — przynaleznosc do kolekcji zna
  // serwer. Poza zasiegiem rabatu nie ma chipow i nie ma kwot po rabacie:
  // zwykly stepper, zadnych obietnic.
  var RABAT_DOTYCZY = KONF.dataset.rabatDotyczy === 'true';

  function drabinka() {
    var out = [];
    String(KONF.dataset.progi || '').split(',').forEach(function (para) {
      var cz = para.split(':');
      if (cz.length !== 2) return;
      var n = parseInt(cz[0].trim(), 10);
      var p = parseFloat(String(cz[1]).replace(/[^0-9.\-]/g, ''));
      if (!isFinite(n) || n < 1) return;
      if (!isFinite(p) || p >= 0) return;          // rabat zapisujemy jako liczbe ujemna
      out.push({ ilosc: n, procent: Math.abs(p) });
    });
    out.sort(function (a, b) { return a.ilosc - b.ilosc; });
    return out;
  }

  var PROGI = RABAT_DOTYCZY ? drabinka() : [];

  // Prog obowiazujacy dla ilosci n to NAJWYZSZY, ktory n spelnia. Przy 3 szt
  // i drabinie 2/5 obowiazuje prog 2 — bo koszyk naprawde go naliczy.
  // (Podswietlenie chipa to co innego: tam wymagamy rownosci — patrz nizej.)
  function obowiazujacy(n) {
    var w = null;
    for (var i = 0; i < PROGI.length; i++) if (n >= PROGI[i].ilosc) w = PROGI[i];
    return w;
  }

  /* ZAOKRAGLANIE — ZMIERZONE NA ZYWYM KOSZYKU, NIE ZALOZONE.

     Shopify liczy rabat NA SZTUCE i obcina do pelnych groszy, dopiero potem
     mnozy przez ilosc. Pomiar (`/cart/add.js` + `/cart.js`, rabat 12%):

        9,22 zl x2  -> rabat 2,20   (wyliczenie „cala linia razy procent": 2,21)
        9,22 zl x5  -> rabat 5,50   (wyliczenie na linii: 5,53)
       14,03 zl x5  -> rabat 8,40   (wyliczenie na linii: 8,41)  <- PREDYKCJA, trafiona

     Wzor liniowy mylil sie o 1-3 grosze — czyli dokladnie o tyle, ile
     wystarczy na reklamacje przy kasie. Stad obciecie na sztuce. */
  function rabatGrosze(cenaGrosze, procent, n) {
    return Math.floor(cenaGrosze * procent / 100) * n;
  }

  var chipy = null, chipyPrzyciski = [];

  function polejlosci() {
    return formularz.querySelector('input[name="quantity"]')
      || document.querySelector('#main-product input[name="quantity"]');
  }

  function ustawIlosc(n) {
    var p = polejlosci();
    if (!p) return;
    p.value = String(n);
    // Stepper motywu (`<quantity-input>`) slucha `change`; inne czesci moga
    // sluchac `input`. Wysylamy oba, zeby nie zalezec od tego, ktore akurat
    // obsluguje ta wersja motywu.
    try {
      p.dispatchEvent(new Event('input', { bubbles: true }));
      p.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) { /* starsza przegladarka — odswiezymy recznie nizej */ }
    odswiez();
  }

  function zbudujChipy() {
    if (!PROGI.length || chipy) return;
    var kotwica = document.querySelector('#main-product .product-form__quantity');
    if (!kotwica) return;

    chipy = document.createElement('div');
    chipy.id = 'pgb-chipy';
    chipy.setAttribute('role', 'group');
    chipy.setAttribute('aria-label', 'Szybki wybór ilości');

    // Pierwszy chip to ILOSC BAZOWA, bez procentu — 1 szt nie jest promocja.
    var ilosci = [1];
    for (var i = 0; i < PROGI.length; i++) ilosci.push(PROGI[i].ilosc);

    ilosci.forEach(function (n) {
      var prog = null;
      for (var j = 0; j < PROGI.length; j++) if (PROGI[j].ilosc === n) prog = PROGI[j];

      var b = document.createElement('button');
      b.type = 'button';                 // nigdy nie wysyla formularza
      b.className = 'pgb-chip';
      b.dataset.ilosc = String(n);

      // BUDOWA JAK KAFEL WYMIARU: ilosc na gorze, badge rabatu pod nia.
      // Badge powstaje ZAWSZE, takze pusty przy jednej sztuce — inaczej chip
      // bez rabatu bylby nizszy od sasiadow i rzad stalby krzywo. Dwa wiersze
      // zamiast jednej linii daja tez wezszy kafel: „5 szt" nad „−25%" miesci
      // sie w jednej trzeciej waskiej kolumny, a „5 −25%" obok siebie nie.
      var liczba = document.createElement('span');
      liczba.className = 'pgb-chip__ilosc';
      liczba.textContent = n + ' szt';
      b.appendChild(liczba);

      var znacznik = document.createElement('span');
      znacznik.className = 'pgb-chip__znacznik';
      znacznik.textContent = prog ? '−' + prog.procent + '%' : '';
      b.appendChild(znacznik);

      b.setAttribute('aria-label', prog ? n + ' szt, rabat ' + prog.procent + ' procent' : n + ' szt');

      b.addEventListener('click', function () { ustawIlosc(n); });
      chipy.appendChild(b);
      chipyPrzyciski.push(b);
    });

    kotwica.appendChild(chipy);
  }

  function odswiezChipy() {
    if (!chipy) return;
    var n = ilosc();
    for (var i = 0; i < chipyPrzyciski.length; i++) {
      var b = chipyPrzyciski[i];
      // Podswietlenie wymaga ROWNOSCI, nie spelnienia progu: przy 3 szt zaden
      // chip nie jest aktywny, bo zaden nie opisuje tej ilosci.
      var aktywny = parseInt(b.dataset.ilosc, 10) === n;
      b.classList.toggle('pgb-chip--aktywny', aktywny);
      b.setAttribute('aria-pressed', aktywny ? 'true' : 'false');
    }
  }

  /* ------------------------------------------- 2b. wiersz „Razem" w LEWEJ kolumnie

     GDZIE I DLACZEGO. „Razem" siedzi pod stepperem i chipami, czyli pod tym,
     co na nie wplywa: ilosc i prog rabatu. Wczesniej staloby nad CTA, w tym
     samym pojemniku co przycisk — a od zadania 23 CTA przenosi sie do PRAWEJ
     kolumny siatki i „Razem" pojechaloby razem z nim, odrywajac sie od swoich
     danych. Wstawiamy je wiec do bloku ilosci; na telefonie, gdzie kolumny sie
     skladaja, daje to naturalna kolejnosc: stepper, chipy, Razem, przycisk.

     DUBEL Z CENA U GORY JUZ NIE ISTNIEJE. Do zadania 23 gorna cena i „Razem"
     istnialy obok siebie celowo (gora orientuje, dol potwierdza). Decyzja
     Wiktora z 18.09: na szablonie gotowy-wzor gorna cena jest UKRYWANA
     (ustawienie `pokaz_cene_gora`), bo dublowala „Razem" i ceny na kaflach
     wymiaru. „Razem" zostaje jedynym widocznym miejscem ceny — i jedynym,
     ktore uwzglednia ILOSC. */

  var wiersz = null, wiersRazem = null, wierszPrzed = null;

  function zbudujRazem() {
    // Blok ilosci (stepper + chipy) to lewa kolumna siatki. Gdyby go nie bylo —
    // np. przy ukrytym wierszu ilosci — wracamy do pojemnika przycisku, zeby
    // „Razem" nie zniknelo z karty w ogole.
    // MIEJSCE ZALEZY OD PRZELACZNIKA, nie od tego, ze tak wygodniej. Przy
    // wylaczonym kompakcie „Razem" zostaje nad przyciskiem — tak jak do
    // zadania 23 — bo szablony spoza gotowego wzoru maja wygladac bez zmian.
    var kompakt = KONF.dataset.siatkaKompakt === 'true';
    var blokIlosci = kompakt ? document.querySelector('#main-product .product-form__quantity') : null;
    var kontener = blokIlosci || document.querySelector('#main-product .product-form__buttons');
    if (!kontener || document.getElementById('pgb-razem')) return;

    wiersz = document.createElement('div');
    wiersz.id = 'pgb-razem';

    var etykieta = document.createElement('span');
    etykieta.className = 'pgb-razem__etykieta';
    etykieta.textContent = KONF.dataset.etykietaRazem || 'Razem (brutto):';

    wiersRazem = document.createElement('span');
    wiersRazem.className = 'pgb-razem__kwota';

    wierszPrzed = document.createElement('s');
    wierszPrzed.className = 'pgb-razem__przed';
    wierszPrzed.hidden = true;

    var linia = document.createElement('span');
    linia.className = 'pgb-razem__linia';
    linia.appendChild(etykieta);
    linia.appendChild(wiersRazem);
    linia.appendChild(wierszPrzed);
    wiersz.appendChild(linia);

    // ZARAZ ZA blokiem ilosci, jako jego RODZENSTWO — nie w srodku. Blok ilosci
    // jest flexem `nowrap` (stepper i chipy maja zostac w jednej linii); wrzucenie
    // „Razem" do srodka wepchneloby je w te sama linie albo zmusilo kontener do
    // zawijania, a wtedy chipy zeskakuja pod stepper CALA GRUPA. Jako rodzenstwo
    // „Razem" dostaje wlasny wiersz siatki i niczego nie rusza.
    // W fallbacku (pojemnik przycisku) zostaje jak bylo: nad przyciskiem.
    if (blokIlosci) kontener.insertAdjacentElement('afterend', wiersz);
    else kontener.insertAdjacentElement('afterbegin', wiersz);
  }

  /* ------------------------------------------------- 2c. pole „Wgraj plik"

     Po zdjeciu kalkulatora CPC z szablonu wizytowek zniknelby razem z nim
     upload — a bez pliku nie ma czego drukowac. Wstawiamy wiec WLASNE pole,
     jako wlasciwosc pozycji zamowienia.

     DLACZEGO TO DZIALA MIMO BRAKU `enctype` NA FORMULARZU: motyw nie wysyla
     formularza natywnie. `product-form.js` buduje `new FormData(this.form)`
     i KASUJE naglowek `Content-Type` (linia 30), wiec fetch ustawia
     multipart z wlasnym boundary — a FormData zabiera pliki niezaleznie od
     atrybutu `enctype`. Sprawdzone w kodzie motywu, nie zalozone. */
  function zbudujPolePliku() {
    var etykieta = KONF.dataset.etykietaPliku || '';
    if (!etykieta || document.getElementById('pgb-plik')) return;
    var kontener = document.querySelector('#main-product .product-form__buttons');
    if (!kontener) return;

    var owijka = document.createElement('div');
    owijka.className = 'pgb-plik';

    var lab = document.createElement('label');
    lab.className = 'pgb-plik__etykieta';
    lab.setAttribute('for', 'pgb-plik');
    lab.textContent = etykieta;

    var inp = document.createElement('input');
    inp.type = 'file';
    inp.id = 'pgb-plik';
    inp.className = 'pgb-plik__pole';
    // Nazwa wlasciwosci trafia na pozycje zamowienia i czyta ja produkcja.
    inp.name = 'properties[' + (KONF.dataset.nazwaPliku || 'Projekt') + ']';
    if (KONF.dataset.typyPliku) inp.accept = KONF.dataset.typyPliku;

    owijka.appendChild(lab);
    owijka.appendChild(inp);
    kontener.insertAdjacentElement('afterbegin', owijka);
  }

  function odswiezRazem() {
    if (!wiersz) return;
    var w = aktualny();
    if (!w) { wiersz.hidden = true; return; }
    wiersz.hidden = false;

    var n = ilosc();
    var regularnie = w.price * n;
    var prog = obowiazujacy(n);

    if (prog) {
      // Rabat ilosciowy: kwota glowna to suma PO rabacie, przekreslona to suma
      // regularna. Formula obcina rabat na sztuce — patrz `rabatGrosze`,
      // gdzie stoi pomiar z zywego koszyka.
      var poRabacie = regularnie - rabatGrosze(w.price, prog.procent, n);
      wiersRazem.textContent = kwota(poRabacie);
      wierszPrzed.textContent = kwota(regularnie);
      wierszPrzed.hidden = false;
      return;
    }

    wiersRazem.textContent = kwota(regularnie);

    // Bez progu wracamy do starego zachowania: przekreslona pokazuje
    // `compare_at`, i TYLKO gdy naprawde jest i naprawde jest wyzsza —
    // w tym katalogu bywa pusty na czesci wariantow, a pusty element
    // zostawialby dziure obok kwoty.
    var przed = w.compare_at_price;
    if (przed && przed > w.price) {
      wierszPrzed.textContent = kwota(przed * n);
      wierszPrzed.hidden = false;
    } else {
      wierszPrzed.textContent = '';
      wierszPrzed.hidden = true;
    }
  }

  /* ------------------------------------------------- 3. pasek podazajacy */

  var pasek = document.getElementById('pers-pasek');

  /* PASEK v2 — stepper i chipy rabatu.

     ZBUDOWANE TUTAJ, NIE W SKRYPCIE PASKA, i to jest cała decyzja
     architektoniczna tej rundy. Ilość ma JEDNO źródło: pole `input[name=quantity]`
     motywu. Gdyby pasek dostał własny stepper w swoim pliku, musiałby trzymać
     własną liczbę — i pierwsza rozbieżność między paskiem a buy boksem byłaby
     zamówieniem na złą ilość.

     Tutaj stepper paska wywołuje to samo `ustawIlosc()`, co chipy w buy boksie:
     zapis idzie do pola motywu, leci `input` i `change`, a `odswiez()` przerysowuje
     OBA miejsca naraz. Synchronizacja w obie strony wychodzi z konstrukcji,
     nie z kopiowania wartości tam i z powrotem.

     Drabinka, strażnik zasięgu i formuła rabatu są te same co w buy boksie —
     `PROGI`, `RABAT_DOTYCZY`, `rabatGrosze`. Poza kolekcjami rabatowymi
     `PROGI` jest puste, więc pasek po prostu nie dostaje chipów. Bez wyjątków. */

  var pasekStepper = null, pasekLiczba = null, pasekChipy = [], pasekPrzed = null;

  function zbudujPasek() {
    if (!pasek) return;
    var inner = pasek.querySelector('.pers-pasek__inner');
    var cta = pasek.querySelector('.pers-pasek__cta');
    if (!inner || pasek.querySelector('.pers-pasek__ilosc')) return;

    /* stepper */
    pasekStepper = document.createElement('div');
    pasekStepper.className = 'pers-pasek__ilosc';

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'pers-pasek__krok';
    minus.textContent = '−';
    minus.setAttribute('aria-label', 'Zmniejsz ilość');

    pasekLiczba = document.createElement('span');
    pasekLiczba.className = 'pers-pasek__liczba';
    pasekLiczba.setAttribute('aria-live', 'polite');

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'pers-pasek__krok';
    plus.textContent = '+';
    plus.setAttribute('aria-label', 'Zwiększ ilość');

    // Minimum 1. Maksimum zostawiamy motywowi — pole ma swoje `min`/`max`,
    // a my nie dokładamy drugiej reguły, która mogłaby się z nim rozjechać.
    minus.addEventListener('click', function () { ustawIlosc(Math.max(1, ilosc() - 1)); });
    plus.addEventListener('click', function () { ustawIlosc(ilosc() + 1); });

    pasekStepper.appendChild(minus);
    pasekStepper.appendChild(pasekLiczba);
    pasekStepper.appendChild(plus);

    /* chipy — tylko gdy drabinka istnieje, czyli gdy rabat naprawde dotyczy */
    var grupaChipow = null;
    if (PROGI.length) {
      grupaChipow = document.createElement('div');
      grupaChipow.className = 'pers-pasek__chipy';
      grupaChipow.setAttribute('role', 'group');
      grupaChipow.setAttribute('aria-label', 'Szybki wybór ilości');

      PROGI.forEach(function (prog) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pers-pasek__chip';
        b.dataset.ilosc = String(prog.ilosc);
        b.innerHTML = '';
        var liczba = document.createElement('span');
        liczba.textContent = String(prog.ilosc);
        var znacznik = document.createElement('span');
        znacznik.className = 'pers-pasek__znacznik';
        znacznik.textContent = '−' + prog.procent + '%';
        b.appendChild(liczba);
        b.appendChild(znacznik);
        b.setAttribute('aria-label', prog.ilosc + ' szt, rabat ' + prog.procent + ' procent');
        b.addEventListener('click', function () { ustawIlosc(prog.ilosc); });
        grupaChipow.appendChild(b);
        pasekChipy.push(b);
      });
    }

    /* przekreslona suma — obok ceny, nie zamiast niej */
    pasekPrzed = document.createElement('s');
    pasekPrzed.className = 'pers-pasek__przed';
    pasekPrzed.hidden = true;
    var info = pasek.querySelector('.pers-pasek__info');
    if (info) info.appendChild(pasekPrzed);

    // Kolejnosc: miniatura/nazwa (info) | stepper | chipy | suma | CTA.
    // Wstawiamy PRZED CTA, zeby przycisk zostal ostatni niezaleznie od tego,
    // co jeszcze do paska trafi pozniej.
    if (cta) {
      inner.insertBefore(pasekStepper, cta);
      if (grupaChipow) inner.insertBefore(grupaChipow, cta);
    } else {
      inner.appendChild(pasekStepper);
      if (grupaChipow) inner.appendChild(grupaChipow);
    }
  }

  function odswiezPasek() {
    if (!pasek) return;
    var w = aktualny();
    var n = ilosc();
    var konfig = pasek.querySelector('.pers-pasek__konfig');
    var cena = pasek.querySelector('.pers-pasek__cena');

    if (konfig) {
      // Ilosc zniknela z opisu: pokazuje ja teraz stepper, a dwa razy ta sama
      // liczba w jednym pasku to szum.
      // Bez kafli (jeden wariant) nie ma wyboru do opisania — a jedyną „opcją"
      // jest wewnętrzne „Default Title" Shopify, którego klient nie powinien widzieć.
      var opis = w && korzen ? w.options.filter(Boolean).join(' · ') : '';
      konfig.textContent = opis;
      konfig.hidden = !opis;
    }

    if (pasekLiczba) pasekLiczba.textContent = String(n);

    for (var i = 0; i < pasekChipy.length; i++) {
      var b = pasekChipy[i];
      // Ta sama regula co w buy boksie: podswietlenie wymaga ROWNOSCI.
      var aktywny = parseInt(b.dataset.ilosc, 10) === n;
      b.classList.toggle('pers-pasek__chip--aktywny', aktywny);
      b.setAttribute('aria-pressed', aktywny ? 'true' : 'false');
    }

    if (cena) {
      if (!w) { cena.hidden = true; if (pasekPrzed) pasekPrzed.hidden = true; return; }
      var regularnie = w.price * n;
      var prog = obowiazujacy(n);
      if (prog) {
        // Ta sama formula co „Razem" — obciecie rabatu NA SZTUCE.
        cena.textContent = kwota(regularnie - rabatGrosze(w.price, prog.procent, n));
        if (pasekPrzed) { pasekPrzed.textContent = kwota(regularnie); pasekPrzed.hidden = false; }
      } else {
        cena.textContent = kwota(regularnie);
        if (pasekPrzed) pasekPrzed.hidden = true;
      }
      cena.hidden = false;
    }
  }

  /* ------------------------------------- 4. przeniesienie wlasnych blokow

     Sekcja renderuje sie jako RODZENSTWO sekcji produktowej, czyli pod obiema
     kolumnami. Karty informacyjne maja byc pod galeria (lewa kolumna), a linia
     zaufania pod ikonami platnosci (prawa). Przenosimy WLASNE wezly — ten sam
     wzorzec co przy pasku platnosci. Wezly motywu zostaja na miejscu. */

  function przenies(id, cel, gdzie) {
    var wezel = document.getElementById(id);
    if (!wezel || !cel) return;
    cel.insertAdjacentElement(gdzie, wezel);
    wezel.hidden = false;
  }

  przenies('pgb-karty', document.querySelector('#main-product .product__media-wrapper'), 'beforeend');

  /* LINIA ZAUFANIA — kotwica, ktora sie NIE PRZEPROWADZA.
   *
   * Pierwsza wersja celowala w `#pers-platnosci`. Wezel istnial, wiec
   * `insertAdjacentElement` nie mial na co narzekac — ale pasek platnosci
   * PRZENOSI SIE SAM, wlasnym skryptem, ktory startuje pozniej. Kotwiczylismy
   * wiec do elementu stojacego jeszcze na swoim pierwotnym miejscu: u gory
   * strony. Efekt: linia ladowala pod okruszkami, poza buy boxem.
   *
   * To nie jest „element nie istnial" tylko „istnial w zlym miejscu" —
   * odmiana lekcji z paska, ostrzejsza, bo zaden straznik jej nie lapie.
   *
   * Teraz kotwica to `.product-form__buttons`, kontener MOTYWU, ktory nigdzie
   * sie nie rusza. Doklejamy na koniec, a pasek platnosci wstawia sie zaraz
   * za przyciskiem — wiec kolejnosc wychodzi ta sama niezaleznie od tego,
   * ktory skrypt zdazy pierwszy. Zero zaleznosci od czasu. */
  przenies('pgb-zaufanie', document.querySelector('#main-product .product-form__buttons'), 'beforeend');

  /* KOLEJNOSC BUY BOXU. Motyw renderuje `<variant-radios>` PO bloku ilosci
   * i przycisku (linia 302 kontra 173) — klient dostawal „kup" przed „wybierz".
   *
   * Przenosimy wezel MOTYWU, co jest dozwolone po sprawdzeniu, od czego zalezy
   * jego wyglad: `section-main-product.css` celuje w `#main-product
   * variant-radios …`, czyli o PRZODKA, nie o bezposredniego rodzica. Po
   * przeniesieniu w obrebie `#main-product` styl zostaje. */
  var wybory = document.querySelector('#main-product variant-radios');
  var koszyk = document.querySelector('#main-product .quantity__and__basket');
  if (wybory && koszyk) koszyk.insertAdjacentElement('beforebegin', wybory);

  /* OSIEROCONY NAGLOWEK „Dodatkowe informacje:". Ten szablon nie ma blokow
   * informacyjnych, wiec motyw renderuje sam naglowek nad pusta lista.
   * Chowamy CALY blok, ale tylko gdy jest pusty — gdyby ktos kiedys dodal
   * bloki w edytorze, naglowek znowu ma sens i zostaje. */
  var dodatkowe = document.querySelector('#main-product .additional__information__wrapper');
  if (dodatkowe && !dodatkowe.querySelector('.additional__information')) {
    dodatkowe.hidden = true;
  }

  /* ---------------------------------------------------------- start */

  function odswiez() { odswiezCeny(); odswiezRazem(); odswiezChipy(); odswiezPasek(); }

  zbudujCeny();
  podmienLegendy();
  skrocWartosci();
  dodajTooltipyKolorow();
  zbudujRazem();
  zbudujPolePliku();
  zbudujChipy();
  zbudujPasek();
  odswiez();

  // Motyw podmienia cene i `input[name=id]` po swojemu; my reagujemy na te
  // same zdarzenia, ktore on obsluguje. Nasluch na korzeniu, wiec dziala takze
  // dla radiow dolozonych pozniej.
  if (korzen) korzen.addEventListener('change', odswiez);   // bez kafli: brak wyboru wariantu
  formularz.addEventListener('change', odswiez);
  var pIlosc = document.querySelector('#main-product input[name="quantity"]');
  if (pIlosc) {
    pIlosc.addEventListener('input', odswiez);
    pIlosc.addEventListener('change', odswiez);
  }
  // Przyciski +/- motywu zmieniaja pole bez zdarzenia `input` w niektorych
  // przegladarkach — lapiemy klik na calym bloku ilosci i odswiezamy po tiku.
  var blokIlosci = document.querySelector('#main-product .quantity');
  if (blokIlosci) {
    blokIlosci.addEventListener('click', function () { setTimeout(odswiez, 0); });
  }

  if (korzen) korzen.classList.add('pgb-on');
})();
